export enum Constants {
  SET_PLAYER = '@startSit/set_player',
  SET_SIDE_ONE = '@startSit/set_side_one',
  SET_SIDE_TWO = '@startSit/set_side_two',
  SET_RESULTS = '@startSit/set_results',
  SET_FF_OPTIONS = '@startSit/set_ff_options',
  SET_SCORING = '@startSit/set_scoring',
  SET_AUTH = '@startSit/set_auth'
}
